"use client";
/*
 * @Description: 
 * @Author: zhanjunwei
 * @Date: 2025-02-25 16:44:19
 * @LastEditors: zhanjunwei
 * @LastEditTime: 2025-02-26 11:11:35
 */
import Link from 'next/link';
import React from 'react';
interface IProps {
  className?: string;
  children: React.ReactNode;
  url?: string;
  isBlank?: boolean;
  style?: React.CSSProperties;
  onClick?: () => void;
}
/**
 * @description 链接组件区,分内跳和外跳
 * 内跳情况：1. 开放跳开放 2. 官网跳官网
 * 外跳情况：1. 跳转到其他网站 2. 开放跳官网 3. 官网跳开放
 * 使用 process.env.NEXT_PUBLIC_BASE_PATH 判断是在 开放平台 或 官网 环境
 * 外跳判断
 * 1. 目标url里是以 http:// 或 https:// 开头
 * 2. 在开放平台里，目标url里不包含 /open-platform
 * 3. 在官网里，目标url里包含 /open-platform
 * 其余情况为内跳
 */
const SSVLink = (props: IProps) => {
  const { children, url, className, isBlank, style, onClick } = props;
  if (!url)
    return (
      <span
        onClick={onClick}
        className={`flex cursor-pointer ${className}`}
        style={style}
      >
        {children}
      </span>
    );
  const isHttpUrl = isSimpleUrl(url);
  const origin = isHttpUrl ? '' : process.env.NEXT_PUBLIC_APP_SERVER_URL;
  const basepath = process.env.NEXT_PUBLIC_BASE_PATH;
  // 当前系统是否在 /open-platform 下
  const isOpenPlatform = basepath === '/open-platform';
  // url 是否包含 /open-platform
  const pattern = /^\/open-platform(\/|$)/;
  const urlInOpenPlatform = pattern.test(url);
  // /open-platform 跳 Home ？
  const openToHome = !isHttpUrl && isOpenPlatform && !urlInOpenPlatform;
  // Home 跳 /open-platform  ？
  const homeToOpen = !isHttpUrl && !isOpenPlatform && urlInOpenPlatform;

  const isBlankLink = isHttpUrl || openToHome || homeToOpen;
  const CurrentLink = () => (
    <Link
      style={style}
      className={`flex cursor-pointer ${className}`}
      href={isOpenPlatform ? delOpenUrl(url) : url}
      target={isBlank ? '_blank' : "_self"}
      onClick={onClick}
    >
      {children}
    </Link>
  );

  const BlankLink = () => (
    <a
      style={style}
      className={`flex cursor-pointer ${className}`}
      href={origin + url}
      target={isBlank ? '_blank' : '_self'}
      rel="noreferrer"
    >
      {children}
    </a>
  );

  if (isBlankLink) {
    return <BlankLink />;
  }

  return <CurrentLink />;
};

export default SSVLink;

export function isSimpleUrl(str: string) {
  // 简易的正则表达式，只检查是否以 http:// 或 https:// 开头，并且后面跟随至少一个字符的域名
  const simpleUrlPattern =
    /^(https?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'$$\*\+,;=.]+$/;
  return simpleUrlPattern.test(str);
}
const delOpenUrl = (url: string) => {
  if (url === '/open-platform') return '/';
  return url.replace('/open-platform', '');
};
